import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";

/* =========================
   Counter Component
========================= */
interface CounterProps {
  end: number;
  prefix?: string;
  suffix?: string;
  afterText?: string;
  duration?: number;
}

const Counter: React.FC<CounterProps> = ({
   end,
  prefix = "",
  suffix = "",
  afterText = "",
  duration = 2000,
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(timer);
      }
      setCount(Math.floor(start));
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration]);

  return (
    <Typography variant="h6" fontWeight={700} color="#0f63a5"
    sx={{
        fontSize: { xs: '0.95rem', md: '1.2rem' }

    }}
    >
      {prefix}
      {count}
      {suffix}
        {afterText}
    </Typography>
  );
};

/* =========================
   Types
========================= */
type StatCard =
  | {
    type: "counter";
    end: number;
    prefix?: string;
    suffix?: string;
    afterText?: string;
    label: string;
  }
  | {
    type: "text";
    label: string;
  };

/* =========================
   Data
========================= */
const stats: StatCard[] = [
  {
    type: "counter",
    end: 2500,
    prefix: "₹",
    suffix: "+",
    afterText: " Crores",
    label: "Revenue Generation",
  },
  {
    type: "counter",
    end: 1000,
    suffix: "+",
    afterText: " Professionals",
    label: "Trained",
  },
  {
    type: "counter",
    end: 100,
    suffix: "+",
    afterText: " CXO's",
    label: "Mentored",
  },
  {
    type: "counter",
    end: 15,
    suffix: "+",
    afterText: " Years",
    label: "High-Value Sales Experience",
  },
];

/* =========================
   Main Section
========================= */
const WhyChooseSection: React.FC = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: "#f7f7f7" ,}}>
      <Container maxWidth="lg" >
        {/* Heading */}
        <Box textAlign="center" mb={8}>
          <Typography variant="h3" fontWeight={800} gutterBottom>
            Why Choose Rajiv Williams ?
          </Typography>

          {/* <Typography
            variant="h6"
            sx={{ color: "#0f63a5", fontWeight: 600, mb: 3 }}
          >
            Your Structured Path To Sales Mastery
          </Typography> */}

          <Typography
            variant="body1"
            sx={{
              maxWidth: "1300px",
              margin: "0 auto",
              color: "#555",
              lineHeight: 1.8,
            }}
          >
            With Over 15+ Years of High-Value Sales Exposure & Leadership
            Mentoring Experience, 
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: "1300px",
              margin: "0 auto",
              color: "#555",
              lineHeight: 1.8,
            }}
          >
            This Coaching is Built on Real Conversations,
             & Real Revenue Environments.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              maxWidth: "800px",
              margin: "0 auto",
              color: "#555",
              lineHeight: 1.8,
              mt: 1,
            }}
          >
            It combines buyer psychology, structured sales frameworks, and
            practical execution, not theory.
          </Typography>
        </Box>

        {/* Cards */}
        <Grid container spacing={4}>
          {stats.map((item, index) => (
            <Grid item xs={6} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: "90px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: 'column',
                  textAlign: "center",
                  borderRadius: "20px",
                  background: "white",
                  transition: "all 0.4s ease",
                  boxShadow: `
    0 4px 10px rgba(0,0,0,0.05),
    0 15px 30px rgba(0,0,0,0.08),
    0 25px 50px rgba(0,0,0,0.12)
  `,
                  "&:hover": {
                    transform: "translateY(-12px)",
                    boxShadow: `
      0 8px 20px rgba(0,0,0,0.08),
      0 25px 45px rgba(0,0,0,0.15),
      0 35px 65px rgba(0,0,0,0.18)
    `,
                  },
                }}
              >
                {item.type === "counter" ? (
                  <>
                    <Counter
                      end={item.end}
                      prefix={item.prefix}
                      suffix={item.suffix}
                      afterText={item.afterText}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        mt: 1, color: "#333",
                        fontWeight: 500,
                        fontSize: { xs: '0.95rem', md: '0.8rem' }

                      }}
                    >
                      {item.label}
                    </Typography>
                  </>
                ) : (
                  <Typography
                    variant="h6"
                    fontWeight={800}
                    color="#0f63a5"
                    sx={{
                      fontSize: {
                        xs: '0.95rem', md: '1.3rem',

                      }
                    }}
                  >
                    {item.label}
                  </Typography>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyChooseSection;
